import {
  StatusIndicator,
  Text,
  type TextProps,
  TextWithTooltip,
} from "@hightouch/htui";
import { ActiveSyncProgressIndicator } from "src/pages/syncs/sync/components/active-sync-progress-indicator";
import {
  SyncRunStatus,
  type SyncRunStatusOrUnknownStatus,
  SyncStatusToText,
  UnknownSyncRunStatus,
  isActiveSyncStatus,
  syncRunStatusToIndicatorVariant,
} from "src/utils/syncs";

const syncStatusToIndicatorText = (
  status: SyncRunStatusOrUnknownStatus,
): string => {
  switch (status) {
    case SyncRunStatus.SUCCESS:
      return "Completed";
    case SyncRunStatus.WARNING:
      return "Completed with errors";
    case SyncRunStatus.FAILED:
      return "Failed";
    case SyncRunStatus.CANCELED:
      return "Canceled by user";
    case SyncRunStatus.INTERRUPTED:
      return "Interrupted";
    case SyncRunStatus.ENQUEUED:
    case SyncRunStatus.QUERYING:
    case SyncRunStatus.PROCESSING:
    case SyncRunStatus.REPORTING:
    case SyncRunStatus.ACTIVE:
    case SyncRunStatus.IN_PROGRESS:
    case SyncRunStatus.ABORTED:
    case SyncRunStatus.PENDING:
    case SyncRunStatus.PREPARING:
    case SyncRunStatus.UNPROCESSABLE:
    case SyncRunStatus.DISABLED:
    case SyncRunStatus.INCOMPLETE:
    case SyncRunStatus.NEVER_RUN:
    case SyncRunStatus.STREAMING:
      return SyncStatusToText[status];
    case UnknownSyncRunStatus:
      return "Unknown status";
  }
};

export const SyncRunStatusIndicator = ({
  status,
  completionRatio,
  labelProps = {},
}: {
  status: SyncRunStatusOrUnknownStatus;
  completionRatio: number | null;
  labelProps?: Pick<TextProps, "size" | "fontWeight">;
}) => {
  if (status === UnknownSyncRunStatus) {
    return (
      <StatusIndicator variant="inactive" ml={1}>
        <Text {...labelProps}>Unknown status</Text>
      </StatusIndicator>
    );
  }
  if (isActiveSyncStatus(status)) {
    return (
      <ActiveSyncProgressIndicator
        status={status}
        completionRatio={completionRatio}
        labelProps={labelProps}
      />
    );
  } else {
    return (
      <StatusIndicator variant={syncRunStatusToIndicatorVariant(status)} ml={1}>
        <TextWithTooltip {...labelProps}>
          {syncStatusToIndicatorText(status)}
        </TextWithTooltip>
      </StatusIndicator>
    );
  }
};
